<template>
  <div
    v-if="_isLoggedIn"
    class="header-cabinet__datetime"
  >
    <span class="header-cabinet__time">{{ time }}</span>
    <span class="header-cabinet__date"> {{ date }}</span>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import dayjs from 'dayjs';
import { mapState } from 'vuex';

export default {
  name: 'DateTime',
  data() {
    return {
      currentDate: {},
      interval: null,
      diffSeconds: 0, // какая разница в секундах c сервером
    };
  },
  watch: {
    serverTime() {
      this.calcDiffSeconds();
    },
  },
  created() {
    try {
      this.currentDate = dayjs();
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    if (this.serverTime) {
      this.calcDiffSeconds();
    }

    this.interval = setInterval(() => {
      this.updateTime();
    }, 5000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  computed: {
    ...mapState({
      serverTime: (state) => state.user.serverTime,
      isLoggedIn: (state) => state.user.isLoggedIn,
    }),
    _isLoggedIn() {
      return this.isLoggedIn && this.$route.name !== 'ConfirmData';
    },
    time() {
      return this.currentDate.format('HH:mm');
    },
    date() {
      return this.currentDate.format('DD.MM.YYYY');
    },
  },
  methods: {
    calcDiffSeconds() {
      this.diffSeconds = dayjs(this.serverTime).unix() - dayjs().unix();
      this.updateTime();
    },
    updateTime() {
      this.currentDate = dayjs().add(this.diffSeconds, 'second');

      this.$store.commit('user/setDynamicServerTime', this.currentDate.format('YYYY-MM-DDTHH:mm:ssZ'));
    },
  },
};
</script>
